
<HomeNavBar />
<InactivityModal />

<div class="container-fluid py-3">

<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
  <div class="d-flex align-items-center">
    <h4 class="mb-0">All Groups</h4>
    <button class="btn bg-white ms-3 rounded-circle shadow-sm d-flex align-items-center justify-content-center border-0 btn-circle-30" data-bs-toggle="modal" data-bs-target="#create_group_modal" @click="open_create_group_modal">
      <i class="bx bx-plus text-dark fs-6"></i>
    </button>
  </div>

  <!-- Desktop version: natural width -->
  <div class="position-relative d-none d-md-block mt-0">
    <i class="bi bi-search text-muted position-absolute top-50 start-0 translate-middle-y ms-3"></i>
    <input
      type="text"
      class="form-control form-control-sm ps-5 shadow-sm rounded"
      placeholder="Search groups"
      v-model="group_search"
    >
  </div>

  <!-- Mobile version: full width -->
  <div class="position-relative d-block d-md-none w-100 mt-2">
    <i class="bi bi-search text-muted position-absolute top-50 start-0 translate-middle-y ms-3"></i>
    <input
      type="text"
      class="form-control form-control-sm ps-5 shadow-sm rounded w-100"
      placeholder="Search groups"
      v-model="group_search"
    >
  </div>
</div>

   <div v-if="loading" class="text-center py-5 w-100">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div v-else-if="filtered_groups.length === 0" class="text-center py-5">
           <div class="text-center mt-5">
            <i class="bi bi-people fs-1 text-muted mb-3 d-block"></i>
            <p class="text-muted">No groups found matching your search.</p>
             <button class="btn btn-primary rounded text-xxs px-4" @click="group_search = ''">Clear Search</button>
          </div>
        </div>

        <div v-else class="row full-width-mobile scrollable-container">
          <div v-for="group in filtered_groups" :key="group.id" class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
            <div class="team-card bg-white p-3 rounded shadow-sm h-100" @click="open_group(group)">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div class="d-flex align-items-center">
                    <a class="rounded-circle bg-yellow p-2 shadow-sm text-change me-3">
                        <i class='bx bxs-group fs-4 text-change'></i>
                    </a>
                     <div class="flex-grow-1 p-1">
                    <div class="mb-0 text-xxs fw-500">
                         {{ group.name }}
                         <i v-if="!group.is_public" class='bx bxs-lock text-primary text-xxs ms-1'></i>
                    </div>
                    <div class="text-xxs text-muted">{{ group.member_count }} Members</div>
                    </div>
                    </div>
                    
                    <!-- Dropdown for creator -->
                    <div v-if="String(group.created_by.id) === String(user_id)" class="dropdown">
                      <i class="bx bx-dots-vertical-rounded cursor-pointer" data-bs-toggle="dropdown" @click.stop></i>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                          <a class="dropdown-item text-xs" @click.stop="open_edit_group_modal(group)">Edit</a>
                        </li>
                        <li>
                          <a class="dropdown-item text-danger text-xs" @click.stop="delete_group(group.id)">Delete</a>
                        </li>
                      </ul>
                    </div>

                  </div>
                   <p class="text-muted small text-truncate-2 mb-3">
                       {{ group.description || 'No description available' }}
                   </p>

                    <button class="btn btn-dark btn-sm w-100 text-xxs rounded" @click.stop="open_group(group)">
                  View Group
                </button>
                </div>
            </div>
        </div>
      </div>
<StickyNav />

<teleport to="body">
<div class="modal fade" id="create_group_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xs test fw-500" id="exampleModalLabel">
          {{ editing ? 'Edit Group' : 'Create a Group' }}
        </p>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <form @submit.prevent="handle_submit">
        <div class="modal-body">
          <div class="mb-3">
            <label for="group_name" class="form-label text-xs fw-500">Group Name <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control rounded text-xs" id="group_name" v-model="group_name"
              placeholder="Enter group name">
            <p v-if="errors.group_name" class="text-danger text-xs">{{ errors.group_name }}</p>
          </div>
          <div class="mb-3">
            <label for="group_description" class="form-label text-xs fw-500">Group Description</label>
            <textarea class="form-control rounded text-xs" id="group_description" v-model="group_description"
              placeholder="Enter group description"></textarea>
          </div>
          <div class="mb-3">
            <label for="is_public" class="form-label text-xs fw-500">Visibility <span
                class="text-danger">*</span></label>
            <select class="form-select rounded text-xs" id="is_public" v-model="is_public" required>
              <option selected hidden>Select visibility type</option>
              <option value="true">Public</option>
              <option value="false">Private</option>
            </select>
          </div>

        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded">
            {{ editing ? 'Update' : 'Post' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
</teleport>

